import Vue from 'vue'
import store from './store/store'
import router from './router'
import firebase from './firebase'
import api from './api'
import bus from './bus'
import messaging from './messaging'
import ApolloClient from './apollo'
import UuidEncoder from 'uuid-encoder';
import rollbar from './services/rollbar';

import getUserListsSub from './gql/lists/getUserListsSub.gql'
import getInvitedByEmail from './gql/invited/getInvitedByEmail.gql'
import addUserToList from "./gql/users/addUserToList.gql";
import deleteInvited from "./gql/invited/deleteInvited.gql"
import deleteUserFromList from "./gql/users/deleteUserFromList.gql"
import getUserUuid from './gql/users/getUserByFirebaseUuid.gql'
import createEventTracking from './gql/events_tracking/createEventTracking.gql'
import updateList from './gql/lists/updateList.gql'
import getListsOfUser from './gql/users/getListsOfUser.gql'
import getPublicLists from './gql/lists/getPublicLists.gql'
import createUser from './gql/users/createUser.gql'
import createCategory from './gql/categories/createCategory.gql'

export default new Vue({
    methods: {
        getUserLists: function (userId) {
            // query without subscription

            // ApolloClient.query({
            //     query: getUserLists,
            //     variables: { userId: userId },
            //     fetchPolicy: "network-only"
            // })
            //     .then((res) => {
            //         store.dispatch('fetchUserLists', res.data.lists);
            //     })

            // query with subscription

            const observer = ApolloClient.subscribe({
                query: getUserListsSub,
                variables: {
                    userId: userId
                },
            })

            observer.subscribe({
                next(data) {
                    store.dispatch('fetchUserLists', data.data.lists);
                },
                error() {
                    // console.error(error)
                },
            })
        },
        addInvitedMemberToLists: function (userId, email) {
            ApolloClient.query({
                query: getInvitedByEmail,
                variables: { email: email }
            })
                .then(async (res) => {
                    for (let i = 0; i < res.data.invited.length; i++) {
                        await api.addUserToList(res.data.invited[i].list_id, userId, "active")
                    }
                    await ApolloClient.mutate({
                        mutation: deleteInvited,
                        variables: {
                            email
                        }
                    });
                })
        },
        addUserToList: async function (list_id, user_id, status) {
            return await ApolloClient.mutate({
                mutation: addUserToList,
                variables: {
                    list_id,
                    user_id,
                    status
                }
            }).catch((error) => { 
                rollbar.error(error);
                alert('There was an error adding the user to the brainstorming session. Please try again later.')
            });
        },
        removeMemberFromList(listId, memberId, userId) {
            ApolloClient.mutate({
                mutation: deleteUserFromList,
                variables: {
                    user_id: memberId,
                    list_id: listId
                }
            })
                .then(() => {
                    api.createEventTracking(
                        "member-deleted",
                        "member-deleted",
                        userId,
                        true
                    );
                });
        },
        sendInvitationEmail: function (email, list_title, name_sender, list_link) {
            let sendEmail = firebase.functions().httpsCallable('sendInvitationToListEmail');
            sendEmail({
                email: email,
                list_title: list_title,
                name_sender: name_sender,
                list_link: list_link
            })
                .then(function () {
                    // alert("Invitation has been sent");
                    // console.log(result);
                });

        },
        sendGenericEmail: function (emails_list, text_title, text_content, subject) {
            let sendEmail = firebase.functions().httpsCallable('sendGenericEmail');
            sendEmail({
                emails_list: emails_list,
                text_title: text_title,
                text_content: text_content,
                subject: subject
            })
                .then(function () {
                    // alert("Invitation has been sent");
                    // console.log(result);
                });
        },
        afterLoginSetup: async function (user) {

            const res = await user.getIdTokenResult(true)
            localStorage.setItem('apollo-token', res.token);
            ApolloClient.link.subscriptionClient.close(false);

            try {
                const { data: { users } } = await ApolloClient.query({
                    query: getUserUuid,
                    variables: { firebase_uuid: user.uid }
                });

                if(!users || users.length === 0) {
                    await api.createUserProfile(user, null, null);
                    return;
                }

                const userInfo = users[0];
                if (userInfo.privacy_consent) {
                    store.dispatch("fetchUser", userInfo);
                    store.dispatch("fetchUserFirebase", user);

                    // check if the user joined a list with a share-link
                    if (localStorage.getItem('list-id-invited-code')) {
                        api.addUserToInvitedListWithLink(userInfo.id)
                    }

                    api.addInvitedMemberToLists(userInfo.id, userInfo.email);
                    api.getUserLists(userInfo.id);
                } else {
                    alert("Oops, there is a problem with your consent to Otti Privacy and Cookie Policy. Write to info@otti.io, we will help you to solve this hassle as soon as possible!")
                }
            } catch(error) {
                rollbar.error(error);
                location.reload();
            }
        },
        createEventTracking: function (event, category, value, db_store) {
            if (process.env.NODE_ENV !== "production") return;

            if (db_store) {
                ApolloClient.mutate({
                    mutation: createEventTracking,
                    variables: {
                        event,
                        category,
                        value
                    }
                })
            }

            if (process.env.NODE_ENV === "production") {
                this.$gtag.event(event, {
                    event_category: category,
                    event_label: value
                });
            }
        },
        updateList: async function (id, status, title, description) {
            return await ApolloClient.mutate({
                mutation: updateList,
                variables: {
                    id,
                    status,
                    title,
                    description
                },
            })
        },
        checkDefaultLists: function (userId) {
            ApolloClient.query({
                query: getListsOfUser,
                variables: { userId: userId },
                fetchPolicy: "network-only"
            })
                .then((res) => {

                    let userList = res.data.lists;

                    const defaultLists = api.getDefaultLists();

                    for (let i = 0; i < defaultLists.length; i++) {
                        let present = false;
                        for (let j = 0; j < userList.length; j++) {
                            if (userList[j].id === defaultLists[i]) {
                                present = true;
                            }
                        }

                        if (!present) {
                            api.addUserToList(
                                defaultLists[i],
                                userId,
                                "active"
                            );
                        }
                    }

                })
        },
        getDefaultLists: async function () {
            return await ApolloClient.query({
                query: getPublicLists
            })
        },
        createUserProfile: async function (user, name, privacy) {
            const email = user.email;
            const firebase_uuid = user.uid;
            let privacy_consent = privacy;

            if (user && (!name || !privacy)) {
                name = localStorage.getItem("user-temp-name");
                privacy_consent = localStorage.getItem("user-temp-privacy");
            }

            if(!privacy_consent && !confirm("Have you read and do you agree with the privary terms and conditions?")) {
                alert("We cannot create your account unless you agree with terms and conditions.");
                router.push("/signup");
                return;
            }
            privacy_consent = true;

            const firstname = name
                ? (name.split(" ").length > 0 ? name.split(" ")[0] : name)
                : email.split("@")[0];
            const surname = name && name.split(" ") && name.split(" ").length > 1 && name.split(" ").slice(1).join(" ") === "" 
                    ? name.split(" ").slice(1).join(" ")
                    : ''; 

            let token = await user.getIdTokenResult(true);
            localStorage.setItem("apollo-token", token.token);

            ApolloClient.link.subscriptionClient.close(false);

            ApolloClient
                .mutate({
                    mutation: createUser,
                    variables: {
                        email,
                        firebase_uuid,
                        name: firstname,
                        surname:  surname,
                        privacy_consent,
                    },
                })
                .then(async (res) => {

                    let defaultListsIds = (await api.getDefaultLists()).data.lists || [];
                    for (let i in defaultListsIds) {
                        await api.addUserToList(
                            defaultListsIds[i].id,
                            res.data.insert_users_one.id,
                            "active"
                        );
                    }

                    api.getUserLists(res.data.insert_users_one.id);

                    store.dispatch("fetchUser", res.data.insert_users_one);
                    store.dispatch("fetchUserFirebase", user);

                    alert(`Welcome on board ${name}!`);

                    this.removeSignupPersistedInfo();

                    if (localStorage.getItem('list-id-invited-code')) {
                        api.addUserToInvitedListWithLink(res.data.insert_users_one.id)
                    } else {
                        router.push("/lists");
                    }
                    // send an email when a new user sign in
                    api.sendGenericEmail(
                        ["davide.benaroio@gmail.com"],
                        "New user signed in!",
                        name + " : " + user.email,
                        "New user signed in: " +
                        name +
                        " (" +
                        user.email +
                        ")"
                    );

                })
                .catch((error) => {
                    rollbar.error(error);
                    bus.$emit("hide-loader");

                    alert(
                        "Oops, something went wrong with the login process. Please give to it another chance and try again. If nothing changes, let us know at info@otti.io"
                    );

                    this.removeSignupPersistedInfo();
                    localStorage.removeItem("apollo-token");

                    user.delete()
                        .catch((error) => {
                            rollbar.error(error);
                            // An error happened.
                        });
                });


        },
        removeSignupPersistedInfo: function () {
            localStorage.removeItem("user-temp-name");
            localStorage.removeItem("user-temp-privacy");
            localStorage.removeItem("signup-in-progress");
        },
        addUserToInvitedListWithLink: function (userDBId) {
            const encoder = new UuidEncoder('base36');
            const listIdDecoded = encoder.decode(localStorage.getItem('list-id-invited-code'))

            api.addUserToList(listIdDecoded, userDBId, "active");

            localStorage.removeItem('list-id-invited-code');
            router.push("/lists/" + listIdDecoded)
        },
        createNewCategory: function(category, userId) {
            return ApolloClient.mutate({
                mutation: createCategory,
                variables: {
                    label: category,
                    userId: userId,
                    default: false
                }
            }).catch((error) => {
                rollbar.error(error);
                alert("Could not create the category. Please try again later.");
            });
        },
        getToken() {
            return messaging.getToken();
        },
        logout() {
            firebase
                .auth()
                .signOut()
                .then(() => {
                    store.dispatch("fetchLogoutSetup");
                    localStorage.removeItem("apollo-token");
                    localStorage.removeItem("lastSavedDate");
                    router.push("/login");
                });
        }
    }, 
});